import { SelectOption } from '@synqo/frontend-component-library';

export type InvoiceSnapshotTableModes = 'all' | 'opos';

export const invoiceSnapshotTableModes: SelectOption<InvoiceSnapshotTableModes>[] = [
    { name: 'rechnungen', label: 'Rechnungen', value: 'all' },
    { name: 'opos', label: 'Offene Posten', value: 'opos' },
];
